<template>
  <el-dialog
    :visible="dialogVisible"
    width="600px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form ref="packageform" :rules="rules" :model="appPackage">
      <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
        <el-input
          v-model="appPackage.name"
          placeholder="请输入套餐名称"
        ></el-input>
      </el-form-item>
      <!-- 套餐类型 -->
      <el-form-item label="套餐类型" :label-width="formLabelWidth">
        <el-select
          v-model="packageType"
          placeholder="请选择套餐类型"
          :disabled="appPackage.packageID != undefined"
        >
          <el-option
            v-for="item in packageList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="packageType !== 'business'">
        <el-form-item prop="version" label="版本" :label-width="formLabelWidth">
          <el-select
            @change="versionChange"
            v-model="appPackage.version"
            placeholder="选择应用版本"
          >
            <el-option
              v-for="item in versions"
              :key="item.appVersion"
              :label="showVersionName(item)"
              :value="item.appVersion"
              v-show="item.templateType == 'RAM'"
            >
            {{showVersionName(item)}}
            <template>
              <el-tag
                v-show="item.arch != '' "
                key="amd64"
                type=""
                effect="dark"
              >
                {{ item.arch }}
              </el-tag>
            </template>
          </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item
        prop="enable"
        label="启用状态"
        :label-width="formLabelWidth"
      >
        <el-switch
          v-model="appPackage.enable"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </el-form-item>
      <div v-if="packageType === 'pay'">
        <!-- 计费方式 -->
        <el-form-item
          prop="billtype"
          label="计费方式"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="appPackage.billtype"
            placeholder="选择应用计费方式"
          >
            <el-option
              v-for="item in billtypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 计费周期 -->
        <el-form-item
          prop="billCycle"
          label="计费周期"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="appPackage.billCycle"
            placeholder="选择计费基础周期"
          >
            <el-option
              v-for="item in billCycles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 周期单价 -->
        <el-form-item
          prop="price"
          label="周期单价"
          :label-width="formLabelWidth"
        >
          <el-input
            type="number"
            :min="0"
            :max="2147483647"
            v-model="appPackage.price"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="packageType !== 'business'">
        <!-- 交付环境 -->
        <el-form-item
          v-if="regionSelect"
          prop="deliveryRegionID"
          label="交付环境"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="appPackage.deliveryRegionID"
            placeholder="选择该套餐默认的交付环境"
          >
            <el-option-group
              v-for="group in deliveryRegions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <!-- 试用套餐和交付审核 -->
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="isTrial"
              label="试用套餐"
              :label-width="formLabelWidth"
            >
              <el-switch
                @change="changeTrial"
                v-model="appPackage.isTrial"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="enableReview"
              label="交付审核"
              :label-width="formLabelWidth"
            >
              <el-switch
                v-model="appPackage.enableReview"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="套餐指标" :label-width="formLabelWidth">
          <el-row
            v-for="(item, index) in appPackage.items"
            :key="index"
            :style="{
              marginTop: index === 0 ? '' : '20px'
            }"
          >
            <el-col :span="8">
              <el-form-item
                :prop="`items[${index}].showName`"
                :rules="rules.showNames"
                :label="index === 0 ? '指标名称' : ''"
                :label-width="formLabelWidth"
                class="clearMt"
              >
                <el-input
                  type="text"
                  placeholder="请输入指标名称"
                  v-model="item.showName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :prop="`items[${index}].name`"
                :label="index === 0 ? '标识' : ''"
                :label-width="formLabelWidth"
                :rules="rules.tags"
                class="clearMt"
              >
                <el-input
                  type="text"
                  v-model="item.name"
                  placeholder="请输入标识"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :prop="`items[${index}].value`"
                :label="index === 0 ? '值' : ''"
                :label-width="formLabelWidth"
                :rules="rules.values"
                class="clearMt clearPd"
              >
                <el-input
                  placeholder="值"
                  v-model="item.value"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="3"
              class="operationIcon"
              :style="{
                marginTop: index === 0 ? '50px' : '13px'
              }"
            >
              <i
                style="font-size: 20px"
                class="el-icon-circle-plus-outline"
                @click="handleAddPackageIndicators"
              ></i>
              <i
                style="font-size: 20px"
                class="el-icon-remove-outline"
                v-show="index !== 0"
                @click="handleDeletePackageIndicators(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </div>

      <el-form-item
        prop="description"
        label="描述"
        :label-width="formLabelWidth"
      >
        <el-input
          type="textarea"
          v-model="appPackage.description"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { createAppPackage, updateAppPackage } from '@/api/app';
import { fetchDeliveryRegionList } from '@/api/delivery';
import { handleRegion } from '@/utils/common';
import { errorHandle } from '@/utils/error';

export default {
  name: 'EditAppPackage',
  props: {
    versions: {
      type: Array
    },
    appPackage: {
      type: Object
    },
    appID: String,
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    const validateItems = (rule, value, callback) => {
      const arr = this.appPackage.items;
      if (arr) {
        arr.map((item, index) => {
          const { name, showName, value } = item;
          if (
            name ||
            showName ||
            value ||
            (index !== 0 && (!name || !showName || !value))
          ) {
            if (!name && rule.field == `items[${index}].name`) {
              callback(new Error('请输入标识'));
            }
            if (!showName && rule.field == `items[${index}].showName`) {
              callback(new Error(' 请输入指标名称'));
            }
            if (!value && rule.field == `items[${index}].value`) {
              callback(new Error('请输入值'));
            }
          }
        });
        callback();
      } else {
        callback();
      }
    };
    return {
      regionSelect: true,
      billtypes: [
        {
          label: '按时间计费',
          value: 'time'
        }
      ],
      billCycles: [
        {
          label: '周',
          value: 'week'
        },
        {
          label: '月度',
          value: 'month'
        },
        {
          label: '季度',
          value: 'quarter'
        },
        {
          label: '年度',
          value: 'year'
        }
      ],
      deliveryRegions: [],
      rules: {
        enable: {
          required: true,
          message: '启用状态必须指定',
          trigger: 'change'
        },
        name: [
          { required: true, message: '请输入套餐名称', trigger: 'change' },
          { max: 32, message: '套餐名称最多32个字符', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请选择关联版本', trigger: 'change' }
        ],
        billtype: [
          { required: true, message: '请选择计费类型', trigger: 'change' }
        ],
        billCycle: [
          { required: true, message: '请选择基础计费周期', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入套餐周期单价', trigger: 'change' },
          {
            validator(rule, value, callback) {
              if (/(^[0-9]\d*$)/.test(value)) {
                if (value > 2147483647) {
                  callback('最大单价是2147483647');
                } else if (value < 0) {
                  callback('最小单价是0');
                } else {
                  callback();
                }
              } else {
                callback(new Error('请输入正整数'));
              }
            },
            trigger: 'change'
          }
        ],
        description: [
          { min: 2, max: 255, message: '描述最多255个字符', trigger: 'change' }
        ],
        showNames: [
          { required: false, message: '请输入指标名称', trigger: 'change' },
          { validator: validateItems, trigger: 'change' }
        ],
        tags: [
          { required: false, message: '请输入标识', trigger: 'change' },
          { validator: validateItems, trigger: 'change' }
        ],
        values: [
          {
            required: false,

            message: '请输入值',
            trigger: 'change'
          },
          { validator: validateItems, trigger: 'change' }
        ]
      },
      app: {},
      title: this.appPackage.packageID != undefined ? '编辑套餐' : '新增套餐',
      formLabelWidth: '100px',
      Loading: false,
      packageList: [
        { id: 'free', name: '免费' },
        { id: 'pay', name: '付费' },
        { id: 'business', name: '商业咨询' }
      ],
      packageType:
        this.appPackage.packageID != undefined
          ? this.appPackage.packageType
          : 'free'
    };
  },
  created() {
    this.fetchRegions();
  },
  mounted() {

  },
  methods: {
    versionChange(v) {
      let saas = false;
      this.versions.map((version) => {
        if (version.appVersion == v && version.deliveryMode == 'saas') {
          saas = true;
        }
      });
      this.regionSelect = !saas;
    },
    handleAddPackageIndicators() {
      this.appPackage.items = [
        ...this.appPackage.items,
        ...[{ name: '', showName: '', value: '' }]
      ];
    },
    handleDeletePackageIndicators(index) {
      this.appPackage.items.splice(index, 1);
    },
    changeTrial(value) {
      if (value == true) {
        this.appPackage.price = 0;
      }
    },
    showVersionName(version) {
      if (version.appVersionAlias) {
        return `${version.appVersion}(${version.appVersionAlias})`;
      }
      return version.appVersion;
    },
    fetchRegions() {
      fetchDeliveryRegionList({
        marketID: this.marketID,
        page: -1,
        pageSize: -1
      })
        .then((res) => {
          if (res) {
            if (res.regions) {
              this.deliveryRegions = handleRegion(res.regions);
            } else {
              this.deliveryRegions = [];
            }
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    submit() {
      this.Loading = true;
      this.$refs.packageform.validate((valid) => {
        if (valid) {
          this.appPackage.marketID = this.marketID;
          this.appPackage.appID = this.appID;
          this.appPackage.price = Number(this.appPackage.price);
          this.appPackage.packageType = this.packageType;
          this.appPackage.templateType = this.appPackage.templateType || 'rainbond';
          const obj = Object.assign({}, this.appPackage);
          let isItems;
          if (obj.items.length >= 1) {
            obj.items.map((item) => {
              const { name, showName, value } = item;
              if (name || showName || value) {
                isItems = true;
              }
            });
          }
          obj.items = isItems ? this.appPackage.items : undefined;
          if (!this.appPackage.packageID) {
            createAppPackage(obj)
              .then((res) => {
                this.Loading = false;
                this.$message.success('套餐创建成功');
                this.onSuccess && this.onSuccess();
                this.reset();
              })
              .catch((err) => {
                this.Loading = false;
                errorHandle(err);
              });
          } else {
            if (obj.packageType && obj.packageType === 'free') {
              obj.billCycle = 'year';
              obj.billtype = 'time';
            } else if (obj.packageType && obj.packageType === 'business') {
              obj.billCycle = '';
              obj.billtype = '';
            }
            updateAppPackage(obj)
              .then((res) => {
                this.Loading = false;
                this.$message.success('套餐更新成功');
                this.onSuccess && this.onSuccess();
                this.reset();
              })
              .catch((err) => {
                this.Loading = false;
                errorHandle(err);
              });
          }
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.packageform.resetFields();
      this.onClose && this.onClose();
    },
    reset() {
      this.$refs.packageform.resetFields();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .clearMt {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-input {
    width: 96%;
  }
}
::v-deep .clearPd {
  .el-input__inner {
    padding: 0 0 0 5px;
  }
}

.operationIcon {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/editAppPackage.vue